import React from 'react';
import { RouterProvider } from './router/RouterProvider';

/**
 * Main application component
 * Using the simplified structure with RouterProvider handling all routing
 */
function App() {
  return <RouterProvider />;
}

export default App;